import Model from './Model'
export default class Presence extends Model {

    resource()
    {
        return 'presences'
    }
}
